import { render } from "./TestcaseAddon.vue?vue&type=template&id=271111ee"
import script from "./TestcaseAddon.vue?vue&type=script&lang=js"
export * from "./TestcaseAddon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__